// src/frontend/src/pages/PaymentSuccess.tsx
import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout/Layout';

const PaymentSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Optional: Track successful payment
    if (sessionId) {
      // Analytics tracking
      console.log('Payment successful:', sessionId);
    }
  }, [sessionId]);

  return (
    <Layout>
      <div className="max-w-2xl mx-auto text-center py-16">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Welcome to PM Coach!
        </h1>
        
        <p className="text-xl text-gray-600 mb-8">
          Your subscription is now active. Continue your PM coaching journey with unlimited access.
        </p>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
          <h3 className="font-semibold text-blue-900 mb-2">What's Next?</h3>
          <ul className="text-left text-blue-800 space-y-2">
            <li>• Access all 50+ coaching scenarios</li>
            <li>• Get real-time coaching tips</li>
            <li>• Track your progress and improvement</li>
            <li>• Export detailed feedback reports</li>
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/dashboard"
            className="bg-blue-600 text-white px-8 py-3 rounded-md hover:bg-blue-700 transition-colors"
          >
            Go to Dashboard
          </Link>
          <Link
            to="/learning-tracks"
            className="border border-gray-300 text-gray-700 px-8 py-3 rounded-md hover:bg-gray-50 transition-colors"
          >
            Start Learning Track
          </Link>
        </div>

        <p className="text-sm text-gray-500 mt-6">
          Check your email for receipt and account details.
        </p>
      </div>
    </Layout>
  );
};

export default PaymentSuccess;